import { TypographyHeading } from "shared/molecules/typography-layout";
import { Box, InputLabel, Paper, FormControl, Select, MenuItem, Pagination, Stack } from "@mui/material";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { table } from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import { GET_NLEARN3_LIVECLASS_GROUP_PACKAGE_SUBSCRIBERS } from "utils/graphql/services/live-classes/queries";
import { Nl3LiveclassGroupPackageSubscribersFilter } from "./filter";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";

export default function Nl3LiveclassGroupPackageSubscribers() {
    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [clearValuesTrigger, setClearValuesTrigger] = useState(0);

    const [getSubscribersList, { loading, error, data }] = useLazyQuery(
        GET_NLEARN3_LIVECLASS_GROUP_PACKAGE_SUBSCRIBERS,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        getSubscribersList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

    const subscribers =
        data?.getNlearn3LiveclassGroupPackageSubscribers
            ?.nlearn3LiveclassGroupPackageSubscribers || [];

    const flattenedData = subscribers.map((item) => ({
        ...item,
        packageName: item?.nlearn3LiveclassPackage?.name,
        batchName: item?.nlearn3LiveclassPackage?.batchName,
        className: item?.nlearn3LiveclassPackage?.className,
        collegeName: item?.nlearn3LiveclassPackage?.collegeName,
        sectionName: item?.nlearn3LiveclassPackage?.sectionName,
        academicYearName: item?.nlearn3LiveclassPackage?.academicYearName,
        streamName: item?.nlearn3LiveclassPackage?.streamName,
        createdAt: utcToIst(item.createdAt),
        updatedAt: utcToIst(item.updatedAt),
    }));

    return (
        <>
            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Nlearn3 Liveclass Group Package Subscribers
            </TypographyHeading>

            <Nl3LiveclassGroupPackageSubscribersFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
                clearValuesTrigger={clearValuesTrigger}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getNlearn3LiveclassGroupPackageSubscribers?.nlearn3LiveclassGroupPackageSubscribers?.length > 0 ? (
                        <CollapsibleTable
                            data={flattenedData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getNlearn3LiveclassGroupPackageSubscribers?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="false"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <Pagination
                            count={Math.ceil(data?.getNlearn3LiveclassGroupPackageSubscribers?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>
            </Paper>
        </>
    )
}
